import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  GeckoCardTable,
  GECKO_CONSTS,
  GeckoModalService,
  GeckoModal,
} from 'ui';
import GeckoRequest from 'services/gecko-request';
import GeckoPagination from 'services/gecko-pagination';
import { connect } from 'react-redux';
import './index.scss';

class Condition extends Component {
  static propTypes = {
    pass: PropTypes.bool,
    type: PropTypes.string,
  };

  render() {
    const icon = this.props.pass ? '✅' : '❌';
    return (
      <li>
        {icon}
        {this.props.type}
      </li>
    );
  }
}

class ConditionGroup extends Component {
  static propTypes = {
    pass: PropTypes.bool,
    type: PropTypes.oneOf(['OR Group', 'AND Group']),
    conditions: PropTypes.array,
  };

  renderCondition([pass, type, conditions]) {
    if (type === 'OR Group' || type === 'AND Group') {
      return <ConditionGroup pass={pass} type={type} conditions={conditions} />;
    }
    return <Condition pass={pass} type={type} />;
  }

  render() {
    const icon = this.props.pass ? '✅' : '❌';
    return (
      <li>
        {icon}
        {this.props.type}
        <ul>{this.props.conditions.map(this.renderCondition)}</ul>
      </li>
    );
  }
}

class Action extends Component {
  static propTypes = {
    pass: PropTypes.bool,
    type: PropTypes.string,
  };

  render() {
    const icon = this.props.pass ? '✅' : '❌';
    return (
      <span>
        {icon} {this.props.type}
      </span>
    );
  }
}

class Results extends Component {
  constructor(props) {
    super(props);
    this.state = { runs: [] };
  }

  static propTypes = {};

  cols = [
    {
      name: 'Workflow ID',
      sortable: 'workflow_id',
      key: 'workflow_id',
    },
    {
      name: 'Context',
      sortable: 'context_id',
      render: (_, row) => {
        return `${row.context_type} - ${row.context_id}`;
      },
    },
    {
      name: 'Status',
      key: 'status',
      sortable: 'status',
      render: (status) => status.toUpperCase(),
    },
    {
      name: 'Conditions',
      key: 'conditions',
      render: (conditions) => {
        return conditions[0] ? '✅' : '❌';
      },
    },
    {
      name: 'Actions',
      key: 'actions',
      render: (actions) => {
        if (!actions) {
          return '-';
        }
        return actions[0] ? '✅' : '❌';
      },
    },
    {
      name: 'Run At',
      key: 'createdAt',
      sortable: 'createdAt',
      type: GECKO_CONSTS.TABLE_CELL_TYPE_DATE,
      render: (createdAt) => new Date(createdAt),
    },
  ];

  componentDidMount() {
    this.fetchResults();
  }

  componentDidUpdate(lastProps) {
    if (
      JSON.stringify(this.props.params) !== JSON.stringify(lastProps.params)
    ) {
      this.fetchResults();
    }
  }

  fetchResults() {
    const params = {};
    if (this.props.params.page) {
      params.page = this.props.params.page;
    }
    if (this.props.params.per_page) {
      params.per_page = this.props.params.per_page;
    }
    if (this.props.params.order_by) {
      params.order_by = this.props.params.order_by;
    }
    if (this.props.params.order) {
      params.order = this.props.params.order;
    }
    GeckoRequest.get('/workflow/results', params)
      .then(({ total, data }) => {
        this.setState({ total, runs: data });
      })
      .catch(console.error);
  }

  showRunModal(run) {
    new GeckoModalService().open(() => {
      return (
        <GeckoModal name="Workflow run">
          <h2>Context</h2>
          {run.context_type === 'Conversation' ? (
            <a href={`/#/conversations/${run.context_id}`}>
              {run.context_type} - {run.context_id}
            </a>
          ) : (
            `${run.context_type} - ${run.context_id}`
          )}
          <h2>Conditions</h2>
          {run.conditions && run.conditions.length ? (
            <ul>
              <ConditionGroup
                pass={run.conditions[0]}
                type={run.conditions[1]}
                conditions={run.conditions[2]}
              />
            </ul>
          ) : (
            'NONE'
          )}
          <h2>Actions</h2>
          {run.actions && run.actions.length ? (
            <ul>
              {run.actions[1].map((action) => (
                <Action pass={action[0]} type={action[1]} />
              ))}
            </ul>
          ) : (
            'NONE'
          )}
        </GeckoModal>
      );
    });
  }

  render() {
    const pagination = {
      changeOrder: GeckoPagination.queryStringChangeOrder,
      changePage: GeckoPagination.queryStringChangePage,
      current_page: this.props.params.page || 1,
      order_by: this.props.params.order_by || 'createdAt',
      sort: this.props.params.sort || 'DESC',
      total_items: this.state.total,
      total_pages: Math.ceil(this.state.total / 50),
    };

    return (
      <div className="Results">
        <div className="content-margin">
          <GeckoCardTable
            name="Workflow Runs"
            cols={this.cols}
            rows={this.state.runs}
            pagination={pagination}
            rowHandler={this.showRunModal.bind(this)}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    params: state.location.params,
  };
};

export default connect(mapStateToProps)(Results);
